// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ja-search-bar[data-v-0186bda0]{width:100%;position:relative;transition:all .2s ease-in;display:flex;flex-wrap:nowrap;align-items:center}.ja-search-bar .search-input-group[data-v-0186bda0]{z-index:1}@media screen and (min-width:1025px){.ja-search-bar[data-v-0186bda0]{width:350px}}@media screen and (max-width:992px){.ja-search-bar[data-v-0186bda0]{justify-content:flex-end}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
